<template>
  <a-card class="GoodsManage">
    <a-form-model layout="inline">
      <a-form-model-item label="商品名称">
        <a-input placeholder="请输入" allow-clear :maxLength="20" v-model="searchForm.name" />
      </a-form-model-item>
      <a-form-model-item label="商品状态">
        <a-select class="serach-item" allowClear v-model="searchForm.status" @keyup.enter="getList(1)" placeholder="请选择">
          <a-select-option value="1">未关联</a-select-option>
          <a-select-option value="2">关联中</a-select-option>
          <a-select-option value="3">已关联</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item style="margin-left: 35px">
        <a-button type="primary" @click="getList(1)">查询</a-button>
        <a-button style="margin: 0 35px 0 15px" @click="resetSearch()">重置</a-button>
      </a-form-model-item>
      <a-form-model-item style="position: absolute; right: 0">
        <a-button @click="RefreshSpu(1)" :disabled="disReload > 0">
          <a-icon type="reload" />
          <span v-if="disReload > 0">{{ reloadText }}</span>
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="table">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        row-key="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="goodsName" class="self_td" slot-scope="text, record">
          <h4>{{ text.spuName }}</h4>
          <span>{{ text.description }}</span>
        </div>
        <div slot="updateTime" class="self_td" slot-scope="text, record">
          <span>修改时间</span>
          <span>{{ text.updateTime.slice(0, 16) }}</span>
        </div>
        <div slot="progress" class="self_td" slot-scope="text, record">
          <span>关联进度</span>
          <span style="text-indent: 13px">{{ text.relatedSkuCount }} / {{ text.skuCount }}</span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a @click="view(text)" v-permission="`/operate/GoodsManage/GoodsDetail`">查看</a>
        </div>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  { title: '商品名称', key: '1', scopedSlots: { customRender: 'goodsName' } },
  { title: '更新时间', key: '2', scopedSlots: { customRender: 'updateTime' } },
  { title: '进度', key: '3', scopedSlots: { customRender: 'progress' } },
  { title: '操作', key: '4', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'goods',
  data() {
    return {
      searchForm: {
        name: undefined,
        status: undefined,
      },
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      disReload: false,
      reloadText: '',
    }
  },
  created() {},
  mounted() {
    // $Bus.$emit('pageHeaderTitle', '商品列表')
    this.getList(1)
  },
  methods: {
    getList(pageIndex) {
      let params = {
        ...this.searchForm,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.tableRelevant.tableLoading = true
      this.$http.operate
        .GetSpuPageList(params)
        .then((res) => {
          this.tableRelevant.tableLoading = false
            this.tableRelevant.tableDataSource = res.data.data.items
            this.tableRelevant.tablePagination.total = res.data.data.totalCount
            this.tableRelevant.tablePagination.current = res.data.data.pageIndex
        
        })
        .catch((err) => {
          this.tableRelevant.tableLoading = false
        })
    },
    resetSearch() {
      this.searchForm = {
        goodsName: '',
        goodsStatus: undefined,
      }
      this.getList(1)
    },
    RefreshSpu() {
      this.$http.operate
        .RefreshSpu()
        .then((res) => {
          this.$message.destroy()
            this.$message.success(res.data.message)
            this.disReload = true
            let time = 30
            let interval = setInterval(() => {
              this.reloadText = `${--time}秒后重试`
              if (!time) {
                this.disReload = false
                clearInterval(interval)
                this.reloadText = ''
              }
            }, 1000)
            setTimeout(() => {
              this.getList()
            }, 1000)
        })
        .catch((err) => {
          this.$message.destroy()
          this.$message.error(res.data.message)
        })
    },
    view(text) {
      this.$router.push({
        path: '/operate/GoodsManage/GoodsDetail',
        query: {
          id: text.id,
        },
      })
    },
  },
}
</script>

<style scoped lang="less">
.self_td {
  display: flex;
  flex-direction: column;
  h4 {
    font-size: 14px;
    margin-bottom: 0;
    font-weight: 600;
  }
  span {
    font-size: 14px;
    color: #777777;
  }
}
/deep/ .ant-table-thead {
  display: none;
}
</style>
